import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import emailjs from "emailjs-com";

const Result = () => {
  return (
    <p className="action">
      Your Message Has Been Successfully Sent. I Will Contact You Soon!
    </p>
  );
};

const Contact = () => {
  const [result, showResult] = useState(false);
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_v8rdzf8",
        "template_577lzbr",
        e.target,
        "user_BDxGm3MKTV4jLdA1IUEiG"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
    showResult(true);
  };
  setTimeout(() => {
    showResult(false);
  }, 5000);
  return (
    <div className="main-contact">
      <div className="container-fluid">
        <Navbar />
        <form id="contact-form" onSubmit={sendEmail}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="full-name"
              className="form-control"
              placeholder="Full Name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Email address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              aria-describedby="emailHelp"
              placeholder="E-mail"
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              className="form-control"
              name="message"
              rows="5"
              placeholder="Message..."
            ></textarea>
          </div>
          <button type="submit" className="btn btn-warning">
            Submit
          </button>
          <div className="row">{result ? <Result /> : null}</div>
        </form>
        <Footer className="contact-footer" />
      </div>
    </div>
  );
};

export default Contact;
